import { createContext } from "react";

const ResourceTypeContext = createContext();

export default ResourceTypeContext